import { anodum } from '@yola/ws-sdk';

const isElementButton = (element) =>
  !!element &&
  (anodum.isTag(element, 'ws-button') ||
    (element.parentNode && anodum.isTag(element.parentNode, 'ws-button')));

export default isElementButton;
